export default "__VITE_ASSET__Cscq7X69__"